export default __webpack_public_path__ + "static/media/rings.3539afbf.svg";